import { Component, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalDirective } from "ngx-bootstrap";
import { DialogsService } from '../../services/dialogs.service';

@Component({
    moduleId: module.id,
    selector: 'angular-alert',
    templateUrl: 'angular-alert.html',
    styleUrls: ['../modal/angular-modal.css']
})
export class AngularAlertComponent {
    Title: string = "";
    Message: SafeHtml = "";
    isAlert: boolean = false;
    isSuccess: boolean = false;

    @ViewChild('alertModal') public alertModal: ModalDirective;

    constructor(private dialogService: DialogsService, private domSanitizer: DomSanitizer) {
        dialogService.alert = this.alert.bind(this);
        dialogService.success = this.success.bind(this);
    }

    private reset() {
        this.Title = "";
        this.Message = "";
    }

    public alert(Title: string, Message: string) {
        this.isAlert = true;
        this.isSuccess = false;
        this.show(Title, Message)
    }

    public success(Title: string, Message: string) {
        this.isAlert = false;
        this.isSuccess = true;
        this.show(Title, Message)
    }

    public show(Title: string, Message: string) {
        this.reset();
        this.Title = Title;
        this.Message = this.domSanitizer.bypassSecurityTrustHtml(Message);
        this.alertModal.show();
    }

    onShown() {
        if (!document.body.classList.contains("modal-open")) document.body.classList.add("modal-open");
    }
    
    onHidden(){
        let modals = document.querySelectorAll(".modal-backdrop");
        if (modals.length == 0) document.body.classList.remove("modal-open");
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/alert/angular-alert.component.ts